export function SplashScreen() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: 'rgba(255, 255, 255, 0.82)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 1400,
        gap: '20px',
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ animation: 'splash-spin 0.9s linear infinite' }}
      >
        <circle cx="24" cy="24" r="20" style={{ stroke: 'var(--color-divider)' }} strokeWidth="4" />
        <path
          d="M44 24a20 20 0 0 0-20-20"
          style={{ stroke: 'var(--color-brand-primary)' }}
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <style>{`
        @keyframes splash-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
